module.exports = __webpack_public_path__ + "f4d1b8f391b510903b93b6cb6c917f6f.pdf";